<!-- Item wrapper -->
<div class="fakturnia-horizontal-navigation-item-wrapper"
    [class.fakturnia-horizontal-navigation-item-has-subtitle]="!!item.subtitle" [ngClass]="item.classes?.wrapper"
    [matMenuTriggerFor]="item.options && item.options.length > 0 ? optionsMenu : null" #menuTrigger="matMenuTrigger"
    (mouseenter)="openMenu()"
    (mouseleave)="closeMenuWithDelay()">

    <!-- Item with an internal link -->
    <ng-container *ngIf="item.link && !item.externalLink && !item.function && !item.disabled">
        <div class="fakturnia-horizontal-navigation-item"
            [ngClass]="{'fakturnia-horizontal-navigation-item-active-forced': item.active}" [routerLink]="[item.link]"
            [fragment]="item.fragment ?? null" [preserveFragment]="item.preserveFragment ?? false"
            [queryParams]="item.queryParams ?? null" [queryParamsHandling]="item.queryParamsHandling ?? null"
            [routerLinkActive]="'fakturnia-horizontal-navigation-item-active'"
            [routerLinkActiveOptions]="isActiveMatchOptions" [matTooltip]="item.tooltip || ''">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Item with an external link -->
    <ng-container *ngIf="item.link && item.externalLink && !item.function && !item.disabled">
        <a class="fakturnia-horizontal-navigation-item" [href]="item.link" [target]="item.target || '_self'"
            [matTooltip]="item.tooltip || ''">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    </ng-container>

    <!-- Item with a function -->
    <ng-container *ngIf="!item.link && item.function && !item.disabled">
        <div class="fakturnia-horizontal-navigation-item"
            [ngClass]="{'fakturnia-horizontal-navigation-item-active-forced': item.active}"
            [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Item with an internal link and function -->
    <ng-container *ngIf="item.link && !item.externalLink && item.function && !item.disabled">
        <div class="fakturnia-horizontal-navigation-item"
            [ngClass]="{'fakturnia-horizontal-navigation-item-active-forced': item.active}" [routerLink]="[item.link]"
            [fragment]="item.fragment ?? null" [preserveFragment]="item.preserveFragment ?? false"
            [queryParams]="item.queryParams ?? null" [queryParamsHandling]="item.queryParamsHandling ?? null"
            [routerLinkActive]="'fakturnia-horizontal-navigation-item-active'"
            [routerLinkActiveOptions]="isActiveMatchOptions" [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Item with an external link and function -->
    <ng-container *ngIf="item.link && item.externalLink && item.function && !item.disabled">
        <a class="fakturnia-horizontal-navigation-item" [href]="item.link" [target]="item.target || '_self'"
            [matTooltip]="item.tooltip || ''" (click)="item.function(item)" mat-menu-item>
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    </ng-container>

    <!-- Item with a no link and no function -->
    <ng-container *ngIf="!item.link && !item.function && !item.disabled">
        <div class="fakturnia-horizontal-navigation-item"
            [ngClass]="{'fakturnia-horizontal-navigation-item-active-forced': item.active}"
            [matTooltip]="item.tooltip || ''">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Item is disabled -->
    <ng-container *ngIf="item.disabled">
        <div class="fakturnia-horizontal-navigation-item fakturnia-horizontal-navigation-item-disabled">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Options Menu -->
    <mat-menu #optionsMenu="matMenu" class="max-w-none" [hasBackdrop]="false">
        <div (mouseenter)="cancelMenuClose()" (mouseleave)="closeMenuImmediately()"
            class="flex flex-col gap-1 p-2">
            <ng-container *ngFor="let option of item.options">
                <a [routerLink]="option.url" [queryParams]="option.queryParams"
                    class="flex items-center p-2 rounded-md transition-colors "
                    [ngClass]="option.classes">
                    <mat-icon *ngIf="option.icon" [svgIcon]="option.icon" class="mr-3"
                        [ngClass]="option.iconClasses"></mat-icon>
                    <span class="font-medium">{{ option.title }}</span>
                </a>
            </ng-container>
        </div>
    </mat-menu>

</div>

<!-- Item template -->
<ng-template #itemTemplate>

    <!-- Icon -->
    <ng-container *ngIf="item.icon">
        <mat-icon class="fakturnia-horizontal-navigation-item-icon" [ngClass]="item.classes?.icon"
            [svgIcon]="item.icon"></mat-icon>
    </ng-container>

    <!-- Title & Subtitle -->
    <div class="fakturnia-horizontal-navigation-item-title-wrapper">
        <div class="fakturnia-horizontal-navigation-item-title">
            <span [ngClass]="item.classes?.title">
                {{item.title}}
            </span>
        </div>
        <ng-container *ngIf="item.subtitle">
            <div class="fakturnia-horizontal-navigation-item-subtitle text-hint">
                <span [ngClass]="item.classes?.subtitle">
                    {{item.subtitle}}
                </span>
            </div>
        </ng-container>
    </div>

     <!-- End Icon -->
     <ng-container *ngIf="item.endIcon">
        <mat-icon class="ml-2" [ngClass]="item.endIcon.iconClasses" [svgIcon]="item.endIcon.icon"></mat-icon>
    </ng-container>

    <!-- Badge -->
    <ng-container *ngIf="item.badge">
        <div class="fakturnia-horizontal-navigation-item-badge" [matTooltip]="item.badge.tooltip || ''">
            <div class="fakturnia-horizontal-navigation-item-badge-content" [ngClass]="item.badge.classes">
                {{item.badge.title}}
            </div>
        </div>
    </ng-container>

</ng-template>